<template>
  <div :key="route.path" class="menu pl-2 overflow-auto">
    <menu-item-group :items="items" open />
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { useRoute } from 'vue-router';
import { SidebarNode } from '@bifrost-dev-docs-mfe/common/types/sidebar';
import MenuItemGroup from '@/components/navigation/left-sidebar/MenuItemGroup.vue';

const route = useRoute();

defineProps({
  items: { type: Array as PropType<SidebarNode[]>, required: false },
});
</script>

<style lang="scss" scoped></style>
